import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "./App.css";
import { AuthProvider } from "./context/AuthContext";
import { ContentProvider } from "./context/ContentContext";
import Layout from "./components/layout/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import AskBrian from "./components/AskBrian";

import Home from "./pages/Home";
import Pathway from "./pages/Pathway";
import RiderTraining from "./pages/RiderTraining";
import DriverTraining from "./pages/DriverTraining";
import Certification from "./pages/Certification";
import Resources from "./pages/Resources";
import Events from "./pages/Events";
import News from "./pages/News";
import NewsArticle from "./pages/NewsArticle";
import Gallery from "./pages/Gallery";
import About from "./pages/About";
import Join from "./pages/Join";
import Contact from "./pages/Contact";
import Assessment from "./pages/Assessment";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import Legal from "./pages/Legal";
import MemberDashboard from "./pages/member/MemberDashboard";
import Community from "./pages/member/Community";
import AdminDashboard from "./pages/admin/AdminDashboard";
import Profile from "./pages/Profile";
import Messaging from "./pages/Messaging";

function App() {
  return (
    <AuthProvider>
      <ContentProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <AskBrian />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/assessment" element={<Assessment />} />
            <Route path="/drivers" element={<Pathway kind="driver" />} />
            <Route path="/riders" element={<Pathway kind="rider" />} />
            <Route path="/riders/training" element={<RiderTraining />} />
            <Route path="/drivers/training" element={<DriverTraining />} />
            <Route path="/certification" element={<Certification />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/events" element={<Events />} />
            <Route path="/news" element={<News />} />
            <Route path="/news/:id" element={<NewsArticle />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/about" element={<About />} />
            <Route path="/join" element={<Join />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Legal page="privacy" />} />
            <Route path="/accessibility" element={<Legal page="accessibility" />} />
            <Route path="/terms" element={<Legal page="terms" />} />
            <Route path="/safeguarding" element={<Legal page="safeguarding" />} />
          </Route>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="/messaging" element={<ProtectedRoute><Messaging /></ProtectedRoute>} />
          <Route
            path="/member"
            element={
              <ProtectedRoute>
                <MemberDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/member/community"
            element={
              <ProtectedRoute>
                <Community />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute adminOnly>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
      </ContentProvider>
    </AuthProvider>
  );
}

export default App;
